export const SolarPanels = (props) => {
  const { size = 24, onClick, verticalAlign, marginLeft, marginRight, top, color, className = ' ' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg xmlns='http://www.w3.org/2000/svg' style={{ verticalAlign }} width={size} height={size} fill='none' viewBox='0 0 24 24'>
        <rect width='18' height='11' x='3' y='11' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' strokeWidth='1.5' rx='2'></rect>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
          d='M9 22V11M15 22V11M21 16.5H3M5 8h1M18 8h1M12 1v1M17 3.05l-.707.707M7 3.05l.707.707M9 8a3 3 0 116 0'
        ></path>
      </svg>
    </span>
  );
};
